import { Laptop } from "lucide-react";

export function RunsNeedComputer() {
  return (
    <section className="mx-auto mt-12 flex max-w-md flex-col items-center gap-3 text-center">
      <Laptop aria-hidden className="size-10 text-muted-foreground" />
      <p>Runs live on the computer where ATS is installed. Open ATS there to start or watch runs. Admin features work here.</p>
    </section>
  );
}
